import React from "react";
import Button from "../ui-elements/button";
import { ThemeContext } from "../../../styles/theme-provider";

import {
  Wrap,
  Logo,
  Title,
  Right,
  PhoneLink,
  Tip,
  SiteTitle,
  AnnouncementText,
  Banner,
} from "./index.styled";

const Header = ({ className, title = "", ...props }) => {
  const { setResetForm } = React.useContext(ThemeContext);
  const [showBanner, setShowBanner] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Show banner when user scrolls down more than 100px
      setShowBanner(scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Wrap className={[className].join(" ")} {...props} id="header">
        <SiteTitle className={"mob-only"} to={"/"}>
          rentals
        </SiteTitle>

        <Logo href={"https://williamsburgwharf.com/"} target="_blank" />
        <Tip>visit masterplan website</Tip>

        <Title to={"/"}>Rental Collection</Title>
        <Right>
          <PhoneLink href="tel:2124902203" aria-label="Call 212 490 2203" title="Call 212 490 2203" />
          <Button
            to="/availability/"
            title="availability"
            className="header"
            onClick={() => setResetForm(true)}
          />
          <Button
            to="/contact/"
            title="schedule a tour"
            className="header web-only"
            onClick={() => setResetForm(true)}
          />
          <Button
            to="/contact/"
            title="contact"
            className="header mob-only"
            onClick={() => setResetForm(true)}
          />
        </Right>
      </Wrap>
      <Banner className={showBanner ? "show" : "hide"}>
        <AnnouncementText>
          Now Leasing
        </AnnouncementText>
      </Banner>
    </>
  );
};
export default Header;
